import React from "react";
import "./Introduction.css";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { ThemeContext } from "../../Context/theme";
// import profilePic from "../../assets/profile4.png";
import profilePic1 from "../../assets/iamaamanjaiswal.jpeg";


export const Introduction = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
      <section id="about" aria-labelledby="about-heading">
        <div className="section" data-aos="fade-right">
          <h2 className="section__title" id="about-heading">
            About <span className="different">Aman Jaiswal</span>
          </h2>
          <div className={"introduction " + themename}>
            <div className="introduction_logocontainer">
              <img
                src={profilePic1}
                alt="Aman Jaiswal, frontend developer specializing in Angular and React, based in Indore, India"
                width="400"
                height="350"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="introduction_datacontainer">
              <p className="introduction_bio">
                Hi everyone, my name is{" "}
                <span className="different">Aman Jaiswal</span> and I am a{" "}
                <span className="different">frontend developer</span> from{" "}
                <span className="different">
                  Indore, Madhya Pradesh, India
                </span>
                . I build web applications with{" "}
                <span className="different">Angular</span>,{" "}
                <span className="different">React</span> and{" "}
                <span className="different">TypeScript</span>, and I care about
                clean component design, accessibility and fast page loads.
              </p>
              <p className="introduction_bio">
                I completed my graduation from{" "}
                <span className="different">
                  Jawaharlal Institute of Technology, Borawan, Khargone Dist.
                  (MP)
                </span>
                , then joined a full stack development course at{" "}
                <span className="different">Shiva Concept Solution</span>, a
                military-type coding school. I currently work at{" "}
                <span className="different">Flair IT Solution Pvt. Ltd.</span>{" "}
                as a senior frontend developer, after building Angular front
                ends for client products at{" "}
                <span className="different">
                  Abacus Consultancy Services Pvt. Ltd.
                </span>
                .
              </p>
              <h3 className="introduction_subhead">
                Terms that can describe me apart from coding:
              </h3>
              <ul className="introduction_traits">
                <li className="different">
                  <span className="icons">
                    <ExitToAppIcon />
                  </span>
                  Music Enthusiast
                </li>
                <li className="different">
                  <span className="icons">
                    <ExitToAppIcon />
                  </span>
                  Creative Thinking
                </li>
                <li className="different">
                  <span className="icons">
                    <ExitToAppIcon />
                  </span>
                  Travelling
                </li>
                <li className="different">
                  <span className="icons">
                    <ExitToAppIcon />
                  </span>
                  Exploring New Places
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
